import { motion } from "framer-motion";
import { MapPin, PackagePlus } from "lucide-react";

const MAP_URL =
  "https://www.openstreetmap.org/export/embed.html?bbox=7.30%2C47.58%2C7.56%2C47.72&layer=mapnik&marker=47.6711%2C7.5031";

const TOWNS = [
  "Illzach",
  "Mulhouse",
  "Kingersheim",
  "Wittenheim",
  "Riedisheim",
  "Rixheim",
  "Sausheim",
  "Pfastatt",
  "Lutterbach",
  "Brunstatt-Didenheim",
  "Richwiller",
  "Staffelfelden",
];

export default function ZoneMap() {
  return (
    <section id="zone" className="bg-white py-16 md:py-24">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="mb-4 inline-flex w-fit rounded-full bg-forest/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-forest">
            Zone de livraison
          </span>
          <h2 className="font-serif text-2xl font-semibold tracking-tight text-ink sm:text-3xl lg:text-4xl">
            Au départ d'<em className="italic text-terra">Illzach</em>, dans un rayon de 20 km
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-ink/65 sm:text-lg">
            Je livre chaque jour à Illzach, Mulhouse et toutes les communes voisines. Et si plusieurs voisins
            commandent ensemble — courses regroupées, colis du même relais — je vais volontiers plus loin.
          </p>
          <ul className="mt-7 flex flex-wrap gap-2.5" data-testid="zone-towns">
            {TOWNS.map((town) => (
              <li
                key={town}
                className="flex items-center gap-1.5 rounded-full bg-cream px-4 py-2 text-sm font-semibold text-forest ring-1 ring-forest/15"
              >
                <MapPin className="h-3.5 w-3.5 text-terra" />
                {town}
              </li>
            ))}
          </ul>
          <div className="mt-8 flex items-start gap-4 rounded-2xl bg-terra/10 p-5">
            <PackagePlus className="mt-0.5 h-6 w-6 shrink-0 text-terra-dark" />
            <p className="text-sm leading-relaxed text-ink/70 sm:text-base">
              <strong className="text-ink">Commandes groupées bienvenues :</strong> vos voisins et vous commandez le
              même jour ? Je regroupe les livraisons, j'étends la zone au-delà des 20 km et le tarif s'adoucit pour
              tout le monde. Appelez-moi au 06 73 31 82 36 pour en parler.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97, y: 24 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="absolute -right-5 -top-5 h-24 w-24 rounded-tr-[3.5rem] border-r-2 border-t-2 border-terra/50" aria-hidden="true" />
          <div className="overflow-hidden rounded-3xl shadow-2xl shadow-forest/15 ring-1 ring-ink/10">
            <iframe
              title="Carte de la zone de livraison autour d'Illzach"
              src={MAP_URL}
              className="h-[420px] w-full border-0"
              loading="lazy"
              data-testid="zone-map"
            />
          </div>
          <p className="mt-3 text-center text-xs text-ink/45">Carte © OpenStreetMap — centré sur Illzach (68)</p>
        </motion.div>
      </div>
    </section>
  );
}
